export const SPACE = ' ';

export const IMAGES_URL = 'https://raw.githubusercontent.com/HybridShivam/Pokemon/master/assets/images/';
export const POKEAPI_URL = 'https://pokeapi.co/api/v2/';
